export const actionTypes = {
  SET_OFFER_LIST: "SET_OFFER_LIST",
  SET_MESSAGE: "SET_MESSAGE",
};